export default __webpack_public_path__ + "static/media/spaceShipC3.7afdc857.webp";